import React from "react";
import dayjs from "dayjs";
import { Check } from "./icons";
import styles from "../publicvehicle.module.css";

const formatDay = (value) => (value ? dayjs(value).format("MMM D, YYYY h:mm A") : "-");

// "Your parking pass is active" confirmation, shown after payment and on later visits to the guest link
const PassActiveCard = ({ data }) => {
  const pass = data?.pass || {};
  const vehicle = data?.vehicle || {};
  const ended = data?.status === "PASS_ENDED";

  return (<>
    <section className={`${styles.card} ${styles.centerText}`}>
      <div className={ended ? styles.neutralCircle : styles.successCircle}><Check /></div>
      <h2 className={styles.cardTitle}>{ended ? "Your parking pass has ended" : "Your parking pass is active"}</h2>
      {!ended && <p className={styles.cardText}>Payment of ${Number(pass.amount || 0).toFixed(2)} received.</p>}
    </section>

    <section className={styles.passCard}>
      <div className={styles.passHead}>
        <span className={styles.sectionLabel}>GUEST PARKING PASS</span>
        <span className={`${styles.chip} ${ended ? styles.chip_neutral : styles.chip_approved}`}>{ended ? "Ended" : "Active"}</span>
      </div>
      <p className={styles.passName}>{pass.label || "Parking pass"}</p>
      <p className={styles.muted}>{[data?.property_name, data?.property_address].filter(Boolean).join(" · ")}</p>
      <dl className={styles.summaryList}>
        {data?.guest_name && <div><dt>Guest</dt><dd>{data.guest_name}</dd></div>}
        <div><dt>Vehicle</dt><dd>{[vehicle.make, vehicle.model].filter(Boolean).join(" ")} <span className={styles.plate}>{vehicle.license}</span></dd></div>
        <div><dt>Valid from</dt><dd>{formatDay(pass.starts_at)}</dd></div>
        <div><dt>Valid until</dt><dd>{formatDay(pass.expires_at)}</dd></div>
      </dl>
    </section>

    {data?.property_phone && <p className={styles.lockNote}>Questions? Call <a href={"tel:" + data.property_phone}>{data.property_phone}</a></p>}
  </>);
};

export default PassActiveCard;
